import SolutionList from './SolutionList';

export default SolutionList;
